'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import { useSearchParams } from 'next/navigation';
import { twMerge } from 'tailwind-merge';
import { DatePicker } from '../../components';
import { useTableFilters } from '../useTableFilters';
import type { ComponentProps } from 'react';
import type { DateRange } from 'react-day-picker';
import type { DateRangePresetKey } from '../../components';
import type { BaseTableFilterProps } from './types';
type DateRangePickerProps = Extract<ComponentProps<typeof DatePicker>, {
  mode: 'range';
}>;
export interface DateRangeTableFilterProps extends BaseTableFilterProps {
  fromDateParam: string;
  toDateParam: string;
  variant: 'dateRange';
  componentProps?: Partial<DateRangePickerProps>;
  placeholder?: string;
  filterOptions?: never;
  groups?: never;
  searchParam?: never;
  value?: never;
  presets?: DateRangePresetKey[];
}
export function DateRangeTableFilter(t0) {
  const $ = _c(22);
  const {
    className,
    label,
    fromDateParam,
    toDateParam,
    searchParamsToClearOnChange,
    componentProps,
    placeholder,
    filterType: t1,
    presets
  } = t0;
  const filterType = t1 === undefined ? "rsc" : t1;
  const searchParams = useSearchParams();
  const {
    updateDateRangeFilter
  } = useTableFilters(filterType);
  const preserveTime = componentProps?.showTimeInput === true;
  const [selectedDateRange, setSelectedDateRange] = useState(undefined);
  let t2;
  let t3;
  if ($[0] !== fromDateParam || $[1] !== preserveTime || $[2] !== searchParams || $[3] !== toDateParam) {
    t2 = () => {
      const fromDateString = searchParams?.get(fromDateParam);
      const toDateString = searchParams?.get(toDateParam);
      const fromTimestamp = fromDateString ? parseInt(fromDateString, 10) : NaN;
      const toTimestamp = toDateString ? parseInt(toDateString, 10) : NaN;
      const from = !Number.isNaN(fromTimestamp) ? new Date(fromTimestamp) : undefined;
      let to;
      if (!Number.isNaN(toTimestamp)) {
        to = new Date(toTimestamp);
        if (!preserveTime) {
          to.setHours(0, 0, 0, 0);
        }
      }
      if (from || to) {
        setSelectedDateRange({
          from,
          to
        });
      } else {
        setSelectedDateRange(undefined);
      }
    };
    t3 = [searchParams, fromDateParam, toDateParam, preserveTime];
    $[0] = fromDateParam;
    $[1] = preserveTime;
    $[2] = searchParams;
    $[3] = toDateParam;
    $[4] = t2;
    $[5] = t3;
  } else {
    t2 = $[4];
    t3 = $[5];
  }
  useEffect(t2, t3);
  let t4;
  if ($[6] !== fromDateParam || $[7] !== preserveTime || $[8] !== searchParamsToClearOnChange || $[9] !== toDateParam || $[10] !== updateDateRangeFilter) {
    t4 = function handleDateRangeChange(dateRange) {
      setSelectedDateRange(dateRange);
      updateDateRangeFilter(fromDateParam, toDateParam, dateRange?.from || null, dateRange?.to || null, searchParamsToClearOnChange, preserveTime);
    };
    $[6] = fromDateParam;
    $[7] = preserveTime;
    $[8] = searchParamsToClearOnChange;
    $[9] = toDateParam;
    $[10] = updateDateRangeFilter;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  const handleDateRangeChange = t4;
  let t5;
  if ($[12] !== className) {
    t5 = twMerge("w-full md:w-auto", className);
    $[12] = className;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  const t6 = componentProps?.["aria-label"] ?? label ?? placeholder ?? `${fromDateParam} to ${toDateParam}`;
  let t7;
  if ($[14] !== componentProps || $[15] !== handleDateRangeChange || $[16] !== placeholder || $[17] !== presets || $[18] !== selectedDateRange || $[19] !== t5 || $[20] !== t6) {
    t7 = <DatePicker {...componentProps} className={t5} aria-label={t6} mode="range" onSelect={handleDateRangeChange} placeholder={placeholder} presets={presets} selected={selectedDateRange} />;
    $[14] = componentProps;
    $[15] = handleDateRangeChange;
    $[16] = placeholder;
    $[17] = presets;
    $[18] = selectedDateRange;
    $[19] = t5;
    $[20] = t6;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  return t7;
}